export type LegacyNoticeRow = {
  id: number
  title: string
  writer: string
  writtenAt: string
}

export type LegacyTransferRow = {
  id: number
  uploadedAt: string
  fileName: string
  parentPk: string
  brand: string
  office: string
  kind: string
  total: number
  success: number
  error: number
  convertedAt: string
}

export const legacyNoticeRows: LegacyNoticeRow[] = []

export const legacyTransferRows: LegacyTransferRow[] = [
  {
    id: 1001,
    uploadedAt: '2026-08-20 10:30',
    fileName: 'mock_customer_bundle.csv',
    parentPk: 'P-1001',
    brand: '데모 브랜드',
    office: '데모 지점',
    kind: '고객 통합 데이터',
    total: 120,
    success: 0,
    error: 0,
    convertedAt: '-',
  },
  {
    id: 1002,
    uploadedAt: '2026-08-19 15:10',
    fileName: 'mock_schedule_bundle.csv',
    parentPk: 'P-1002',
    brand: '데모 브랜드',
    office: '데모 지점',
    kind: '스케줄 통합 데이터',
    total: 48,
    success: 48,
    error: 0,
    convertedAt: '2026-08-19 16:00',
  },
]
